import { $lang } from '@msdk/common'
import {
  GenericFieldValue,
  OptionsetFieldDefinition,
  OptionSetModel,
  readOptionSetModelByName,
} from '@msdk/definitions'
import { COLORS, IconSelector, styled, Typography } from '@msdk/ui'
import React from 'react'
import { useRecoilValue } from 'recoil'

interface Props {
  value?: GenericFieldValue
  fieldDef: OptionsetFieldDefinition
}

const OptionWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 4px;
`

const StyledTypography = styled(Typography)`
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

export function OptionSetFieldRenderer({ value, fieldDef }: Props) {
  const lang = useRecoilValue($lang)
  const optModel = readOptionSetModelByName(fieldDef.family) as OptionSetModel
  const opt = optModel.options.find((op) => op.value === value?.value)

  return (
    <OptionWrapper>
      {opt?.icon && <IconSelector iconName={opt.icon} color={opt?.fontColor ?? COLORS.text.primary} />}
      <StyledTypography variant="body1" color={opt?.fontColor ?? COLORS.text.primary}>
        {value ? value.toStringForView(lang) : '-'}
      </StyledTypography>
    </OptionWrapper>
  )
}
